<template>
  <div>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="settleAccountsRef"
      class="vxe-table-element"
      size="mini"
      align="center"
      :auto-resize="true"
      :data="tableData"
      :columns="tableColumns"
      :valid-config="{ autoPos: true, message: 'inline' }"
      :edit-config="{ trigger: 'click', mode: 'row' }"
      height="400"
      @cell-dblclick="dblclickEvent"
      :key="keyTime"
    ></vxe-grid>
    <!-- 分页 -->
    <IPagination
      ref="ipaginationRef"
      :total="tableTotal"
      :multipleSelection="multipleSelection"
      @changePageHandler="changePageHandler"
    />
    <!-- <div class="pagination"> -->
    <!-- <el-pagination
        ref="page"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-count="page.pages"
        :page-size="page.pageSize"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination> -->
    <!-- <IPagination /> -->
    <!-- </div> -->
  </div>
</template>

<script>
  import jumpDetailMixin from '../mixins/jumpDetailMixin.js';
  import billDataMixin from '../mixins/billDataMixin.js';
  export default {
    name: 'ApprovalTable',
    props: ['columnList', 'orderName', 'activeTab', 'indexType'],
    mixins: [jumpDetailMixin, billDataMixin],
    data() {
      return {
        tableData: [],
        tableTotal: 0,
        multipleSelection: [],
        loading: false,
        // tableColumns: [],
        load: false,
        page: {
          pages: 0,
          pageSize: 10,
          pageNum: 1,
          total: 0,
        },
      };
    },
    computed: {
      tableColumns() {
        return [
          { type: 'seq', title: '序号', width: 50 },
          {
            field: 'orderTypeName',
            title: '单据类型',
            visible: true,
          },
          {
            field: 'orderName',
            title: '名称',
            visible: true,
          },
          {
            field: 'orderNo',
            title: '单据号',
            slots: {
              default: ({ row }) => {
                return [
                  <a href="javascript:void(0)" onClick={() => this.jumpToDetail(row)}>
                    {row.orderNo}
                  </a>,
                  //  row.receivableSettlementNo
                ];
              },
            },
            visible: true,
          },
          // {
          //   field: 'approvalPerson',
          //   title: '当前审批人',
          //   visible: true,
          // },
        ];
      },
    },
    mounted() {
      this.businessGroup = this.userInfo.businessGroup;
      this.$refs.ipaginationRef.handleSizeChange(10);
    },
    methods: {
      changePageHandler(pageNum, pageSize) {
        this.page.pageNum = pageNum;
        this.page.pageSize = pageSize;
        console.log(pageNum, pageSize);
        this.getTableData();
      },
      handleSizeChange(value) {
        this.page.pageSize = value;
        // this.getData();
      },
      handleCurrentChange(value) {
        this.page.pageNum = value;
        // this.getData();
      },
      async getTableData() {
        // console.log('请求审批中数据');
        this.tableData = [];
        this.keyTime = new Date().getTime();
        this.getDataByOrderType('03');
      },
    },
    watch: {
      orderName: {
        handler() {
          console.log('表格数据变化');
          this.keyTime = new Date().getTime();
          if (this.activeTab == '03') {
            this.changePageHandler(1, 10);
            // this.getTableData();
          }
        },
        immediate: true,
        deep: true,
      },
      // activeTab: {
      //   handler() {
      //     console.log('表格数据变化');
      //     this.keyTime = new Date().getTime();
      //     this.changePageHandler(1, 10);
      //   },
      //   immediate: true,
      //   deep: true,
      // },
    },
  };
</script>

<style></style>
